import { useState } from "react";
import { Table, Space, Button, Tooltip, Popconfirm, Typography } from "antd";
import { EditOutlined, DeleteOutlined } from "@ant-design/icons";

const { Text } = Typography;

export default function UnidadMedidaTable({ data, loading, onEdit, onDelete, permissionUpdate, permissionDelete }) {

  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10
  });

  const handleTableChange = (paginationInfo) => {
    setPagination(paginationInfo);
  };

  const renderTextWrap = (value, width = 220) => (
    <Text
      style={{
        display: "block",
        maxWidth: width,
        whiteSpace: "normal",
        wordBreak: "break-word"
      }}
    >
      {value}
    </Text>
  );

  const columns = [
    {
      title: "Unidad de Medida",
      dataIndex: "unidad_medida",
      width: 300,
      render: (text) => renderTextWrap(text, 300)
    },
    {
      title: "Acciones",
      width: 120,
      align: "center",
      render: (_, record) => (
        <Space>
          {permissionUpdate && (
            <Tooltip title="Editar">
              <Button
                icon={<EditOutlined />}
                size="small"
                onClick={() => onEdit(record)}
              />
            </Tooltip>
          )}

          {permissionDelete && (
            <Popconfirm
              title="¿Eliminar unidad?"
              okText="Eliminar"
              cancelText="Cancelar"
              onConfirm={() => onDelete(record)}
            >
              <Button
                danger
                size="small"
                icon={<DeleteOutlined />}
              />
            </Popconfirm>
          )}
        </Space>
      )
    }
  ];

  return (
    <Table
      rowKey="oid"
      columns={columns}
      dataSource={data}
      loading={loading}
      bordered
      size="middle"
      pagination={{
        ...pagination,
        showSizeChanger: true,
        showQuickJumper: true,
        pageSizeOptions: ["10", "20", "30"],
        showTotal: (total) => `Total ${total} unidades`
      }}
      onChange={handleTableChange}
      style={{
        margin: "0 auto",
        borderRadius: 8,
        overflow: "hidden"
      }}
    />
  );
}